import { Parser } from 'expr-eval-fork';

// Validates a compound metric expression locally by evaluating it with each
// referenced metric ID substituted for a placeholder value. If evaluation
// throws — unbalanced parentheses, a stray operator, or a token that isn't a
// provided metric ID — the expression is invalid. Used to gate both the form's
// save button and the live preview request so we never send an expression the
// backend can't resolve (which surfaces as "Invalid expression" noise).
const isValidCompoundMetricExpression = ({
  expression,
  metricIds,
}: {
  expression: string;
  metricIds: string[];
}): boolean => {
  try {
    // Replace longest IDs first so a shorter ID can't corrupt a longer one it
    // happens to be a substring of. split/join replaces every occurrence.
    const expressionWithValues = [...metricIds]
      .sort((a, b) => b.length - a.length)
      .reduce(
        (expr, metricId) => expr.split(metricId).join('1'),
        expression.toString(),
      );

    const parser = new Parser();
    parser.functions.annualized = (metricValue: number) => metricValue;
    parser.evaluate(expressionWithValues);
    return true;
  } catch {
    return false;
  }
};

export default isValidCompoundMetricExpression;
